// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD-7zIUMiXVvXZglw1b1DEJkPB6QTdeyMM",
  authDomain: "matrix-116e9.firebaseapp.com",
  projectId: "matrix-116e9",
  storageBucket: "matrix-116e9.appspot.com",
  messagingSenderId: "52112589309",
  appId: "1:52112589309:web:3e90e1f828a72290f89994"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);